function o(r, e, c) {
  const t = (n) => Object.is(n, -0) ? 0 : n;
  return r < e ? t(e) : r > c ? t(c) : t(r);
}
export {
  o as c
};
